"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styles = {
    getBaseStyle: function (props) {
        var theme = props.theme, color = props.color, fontColor = props.fontColor, inverse = props.inverse, _a = props.size, size = _a === void 0 ? 'medium' : _a, disabled = props.disabled, ghost = props.ghost, minimal = props.minimal;
        var componentStyles = theme.components.button;
        var primary = (inverse || minimal) ? fontColor : color;
        var secondary = (inverse || minimal) ? color : fontColor;
        var options = tslib_1.__assign({}, props, { primary: primary,
            secondary: secondary });
        var defaultStyles = componentStyles.defaults(options);
        var sizeStyles = componentStyles.sizes[size];
        var disabledStyles = disabled ? componentStyles.disabled(options) : {};
        var inverseStyles = inverse ? componentStyles.inverse(options) : {};
        var linkStyled = minimal ? componentStyles.minimal(options) : {};
        var ghostStyles = ghost ? componentStyles.ghost(options) : {};
        return tslib_1.__assign({}, defaultStyles, sizeStyles, inverseStyles, ghostStyles, linkStyled, disabledStyles);
    },
    getBlockStyle: function (_a) {
        var fullWidth = _a.fullWidth;
        return fullWidth && ({ width: '100%' });
    },
    getCircleButtonStyle: function (_a) {
        var theme = _a.theme, shape = _a.shape, _b = _a.size, size = _b === void 0 ? 'medium' : _b, minimal = _a.minimal, disabled = _a.disabled;
        var minimalStyles = minimal && !disabled && theme.components.button.circle.minimal ? tslib_1.__assign({}, theme.components.button.circle.minimal.enabled) : {};
        return shape === 'circle' ? (tslib_1.__assign({ paddingLeft: 0, paddingRight: 0, height: theme.components.button.circle[size], width: theme.components.button.circle[size] }, minimalStyles)) : null;
    }
};
exports.default = styles;
